import { render, staticRenderFns } from "./AssetSection.vue?vue&type=template&id=913c3ffc&scoped=true&"
import script from "./AssetSection.vue?vue&type=script&lang=ts&"
export * from "./AssetSection.vue?vue&type=script&lang=ts&"
import style0 from "./AssetSection.vue?vue&type=style&index=0&id=913c3ffc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "913c3ffc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VIcon,VLayout,VSpacer})
